import React from 'react'

// Components
import FormContact from 'components/flex/Form/FormContact'
import FormConsultation from 'components/flex/Form/FormConsultation'
import FormInvoice from './FormInvoice'
import FormMaintenance from './FormMaintenance'
import FormFeedback from './FormFeedback'

export interface FormProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Form
  location?: any
}

interface PostProps {
  [key: string]: any
}

const FormShell: React.FC<FormProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    contact: FormContact,
    consultation: FormConsultation,
    invoice: FormInvoice,
    maintenance: FormMaintenance,
    feedback: FormFeedback,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default FormShell
